import { defineMessages } from "react-intl";

const CREATE = "create";

const createMessages = defineMessages({
  createYourAccount: {
    id: `${CREATE}.create-your-account`,
    defaultMessage: "Create your account"
  },
  alreadyHaveAnAccount: {
    id: `${CREATE}.already-have-an-account`,
    defaultMessage: "Already have an account? <a>Sign in.</a>"
  }
});

export default createMessages;
